import controller from './vd-autocomplete-filter.controller'
import template from './vd-autocomplete-filter.html'

export default {
  bindings: {
    source: '<',
    buttonLabel: '<',
  },
  require: {
    ngModelCtrl: '^ngModel',
    form: '?^^form',
  },
  controller,
  template,
}
